import { WifiOff } from 'lucide-react';

interface EstadoErrorReintentarProps {
  /** Qué no se pudo cargar, p. ej. «el diario». */
  titulo?: string;
  onReintentar: () => void;
}

/**
 * Estado de error de carga: distingue «no se pudo cargar» de «no hay datos».
 * Nunca debe confundirse con un vacío (data-layer.md: fail-visible).
 */
export function EstadoErrorReintentar({
  titulo = 'No se pudo cargar',
  onReintentar,
}: EstadoErrorReintentarProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center h-48 gap-3 p-4 text-center text-muted-foreground"
    >
      <WifiOff className="w-10 h-10 opacity-60" aria-hidden="true" />
      <p className="text-sm font-bold text-foreground">{titulo}</p>
      <p className="text-xs max-w-[280px]">
        No se pudo conectar con el servidor. No es que no tengas registros: no hemos podido leerlos.
      </p>
      <button
        type="button"
        onClick={onReintentar}
        className="px-4 py-2 rounded-xl text-xs font-bold bg-secondary text-foreground active:scale-95 transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        Reintentar
      </button>
    </div>
  );
}
